module.exports = __webpack_public_path__ + "static/media/tnt2x.55e364b6.jpg";